import siteConfigService from '@/services/site.config.service';
import { COMMONLINKS } from '@/entities/commonLinks';
import { DEVICE } from '@/entities/device';
import BrowserService from '@/services/browser.service';

export default class WindowUtils {
  public static setLocationHref(newHref: string): void {
    window.location.href = newHref;
  }

  public static getLocationHref(): string {
    return window.location.href;
  }

  public static reload(): void {
    return window.location.reload();
  }

  public static getHostName(): string {
    return window.location.hostname;
  }

  public static getPageYOffset(): number {
    return window.pageYOffset;
  }

  public static async openNewWindow(url: string, windowName: string, windowFeatures: string):Promise<void> {
    const ngserviceUrl:string = await siteConfigService.getApiEndpoint('POSTSALES_PREFIX_API');
    // TODO -> This logic is not required to be put here. Calling point should have this logic. this is not the way to write utility functions.
    if (url.indexOf('confirmationOfSale') >= 0) {
      url = ngserviceUrl + url;
    }
    if (BrowserService.getDevice().includes(DEVICE.IOS_APP_SHELL) || BrowserService.getDevice().includes(DEVICE.ANDROID_APP_SHELL)) {
      if (url.indexOf('COMMONLINKS')) {
        WindowUtils.setLocationHref(`${url}&__appShellFileType=pdf`);
      }
    } else {
      window.open(url, windowName, windowFeatures);
    }
  }

  public static isCameraAvaiable(): boolean {
    const md = navigator.mediaDevices;
    if (!md || !md.enumerateDevices) return false;
    return true;
  }
}
